import React from 'react';
import logo from '../../Assets/images/Airswift Primary Logo (Black Text).png';
import styles from './RightToBeForgotten.module.scss';

function ThankYou() {
  return (
    <div className={styles.rtfb}>
      <img className={styles.rtfb__image} src={logo} alt="" />
      <div className={styles.rtfb__content}>
        <p className={styles.title}>Thank you for submitting your request. </p>
        <p className={styles.subtitle}>
          We will review your request in line with the specifications set out by the GDPR and action your request
          accordingly. Your request can take up to one calendar month to process and you have the option to cancel this
          request during this period.
        </p>

        <p className={styles.policy}>
          If your request is complex or you make more than one, the response time may be a maximum of three calendar
          months, starting from the day of receipt.
        </p>
      </div>
    </div>
  );
}

export default ThankYou;
